<template>
  <div>
    <v-data-table
      dense
      :headers="config.headers"
      :items="items"
      :options.sync="options"
      :multi-sort="true"
      :server-items-length="meta.total"
      :header-props="{
        sortIcon: 'mdi-arrow-down',
      }"
      :loading="loading"
      class="elevation-1"
      :footer-props="{ 'items-per-page-options': footerItemsPerPage }"
      item-class="color"
      :no-data-text="noDataMessage"
    >
      <template v-slot:top>
        <v-toolbar v-if="showToolbar" flat>
          <v-toolbar-title
            v-if="showHeaderTitle && $vuetify.breakpoint.name !== 'xs'"
            class="pr-2"
          >
            {{ config.header }}
          </v-toolbar-title>
          <v-btn
            v-if="allowAdd && !openModal"
            x-small
            :to="{ name: `${config.routerBase}.new` }"
            color="secondary"
          >
            {{ config.createButtonText || 'Add' }}
          </v-btn>
          <v-btn
            v-if="allowAdd && openModal"
            x-small
            color="secondary"
            @click="addModal = true"
          >
            Add
          </v-btn>
          <v-divider
            v-if="showHeaderTitle"
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-dialog
            v-if="showFilters && config.filters"
            v-model="filterDialog"
            @keydown.esc="filterDialog = false"
            max-width="500px"
          >
            <template v-slot:activator="{ on }">
              <v-icon size="15" class="mr-4" v-on="on" color="secondary"
                >$filter</v-icon
              >
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">Filter By:</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col
                      v-for="filter in config.filters"
                      cols="12"
                      sm="6"
                      :md="(config.reportFileName === 'commissions_report' && filter.name === 'rateKey') ||
                        (config.reportFileName === 'invoice_report' && filter.name === 'status')
                            ? '12'
                            : '6'"
                      :key="filter.name"
                      :class="config.reportFileName === 'transaction_details_report' && filter.name === 'minAmount'
                            ? 'tw-mr-px'
                            : config.reportFileName === 'transaction_details_report' && filter.name === 'maxAmount'
                            ? 'tw--ml-px'
                            // : config.reportFileName === 'residual_report' && filter.name === 'startDate'
                            // ? 'tw-mr-px'
                            : ''"
                    >
                      <v-autocomplete
                        v-if="filter.type === EntityFilterType.TYPE_AHEAD"
                        v-model="filter.value"
                        :items="autoCompleteSearchResults"
                        :loading="autoCompleteSearchLoading"
                        :search-input.sync="autoCompleteSearch"
                        color="white"
                        hide-no-data
                        hide-selected
                        :label="filter.value || filter.display"
                        placeholder="Start typing to Search"
                        @keyup.enter="applyFilter"
                      />
                      <v-text-field
                        v-if="filter.type === EntityFilterType.TEXT"
                        v-model="filter.value"
                        :label="filter.display"
                        @keyup.enter="applyFilter"
                      />
                      <Amount
                        v-if="filter.type === EntityFilterType.MONEY"
                        @updateAmountFieldValue="updateModel"
                        :label="filter.display"
                        v-model="filter.value"
                        :extra="filter"
                        @keyup.enter="applyFilter"
                        outlined
                        dense
                      />
                      <v-select
                        v-if="filter.type === EntityFilterType.SELECT"
                        v-model="filter.value"
                        :items="filter.items"
                        item-text="display"
                        :label="filter.display"
                        @keyup.enter="applyFilter"
                      />
                      <v-select
                        v-if="filter.type === EntityFilterType.SELECT_CHECK"
                        v-model="filter.value"
                        :items="filter.items"
                        item-text="display"
                        :label="filter.display"
                        multiple
                        @keyup.enter="applyFilter"
                      />
                      <template
                        v-if="filter.type === EntityFilterType.YEAR_MONTH && config.reportFileName === 'residual_report'"
                      >
                        <v-row class="m-0 p-0">
                          <v-col v-for="subFilter in filter.compositeValues" :class="subFilter.class" :key="subFilter.name">
                            <v-select
                              item-text="display"
                              :label="subFilter.label"
                              :items="subFilter.items"
                              v-model="subFilter.value"
                              @keyup.enter="applyFilter"
                            />
                          </v-col>
                        </v-row>
                      </template>
                      <v-menu
                        ref="menu"
                        v-model="filter.open"
                        v-if="
                          filter.type === EntityFilterType.DATE ||
                          (filter.type === EntityFilterType.DATE_MONTH && config.reportFileName !== 'residual_report')
                        "
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            :value="filter.value"
                            :label="filter.display"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            @keyup.enter="applyFilter"
                          />
                        </template>
                        <v-date-picker
                          class="white--text"
                          v-model="filter.value"
                          :type="
                            filter.type === EntityFilterType.DATE
                              ? 'date'
                              : 'month'
                          "
                          :max="
                            config.reportFileName === 'invoice_report' &&
                              ['startDueDate', 'endDueDate'].includes(filter.name) ? '' : new Date().toISOString()
                            "
                          no-title
                          scrollable
                        >
                          <v-spacer />
                          <v-btn
                            small
                            text
                            color="secondary"
                            @click="filter.open = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            small
                            text
                            color="secondary"
                            @click="filter.open = false"
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn small color="secondary" text @click="resetFilters">
                  Reset
                </v-btn>
                <v-btn small color="secondary" text @click="applyFilter">
                  Apply
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-spacer />
          <v-text-field
            v-if="showSearch"
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            class="pr-4"
            single-line
            hide-details
          />
          <template v-if="showCustomSummary">
            <slot name="customSummary" v-bind:slotProps="meta" />
          </template>
          <template v-if="$slots.exportCsvButtonInfo">
            <div class="mr-4">
              <slot name="exportCsvButtonInfo" />
            </div>
          </template>
          <v-btn
            v-if="showDownloadCsvButton"
            :loading="exportingCsv"
            color="secondary"
            dark
            class="mb-2"
            small
            @click="downloadCsv"
          >
            Export as CSV
          </v-btn>
          <v-btn
            v-if="showCustomButton"
            color="secondary"
            dark
            class="mb-2"
            small
            @click="customModal = true"
          >
            {{ customButtonText }}
          </v-btn>
        </v-toolbar>
      </template>
      <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
        <slot :name="slot" v-bind="scope"/>
      </template>
      <template v-if="showActions" v-slot:item.actions="{ item }">
        <v-row align="center" justify="space-around">
          <v-btn
            :to="{ name: `${config.routerBase}.view`, params: { id: item.id } }"
            v-if="allowView(item)"
            color="secondary"
            dense
            x-small
          >
            View
          </v-btn>
          <v-btn
            v-if="showLoginButton"
            :href="item.domain.url"
            target="_blank"
            color="secondary"
            dense
            x-small
          >
            Login
          </v-btn>
          <v-btn
            v-if="showEditButton && !openModal"
            :disabled="!allowEdit(item)"
            color="secondary"
            dense
            x-small
            :to="{ name: `${config.routerBase}.edit`, params: { id: item.id } }"
          >
            Edit
          </v-btn>
          <v-btn
            v-if="showEditButton && openModal"
            :disabled="!allowEdit(item)"
            color="secondary"
            dense
            x-small
            @click="editModalFunction(item.id)"
          >
            Edit
          </v-btn>
          <v-btn
            v-if="showDeleteButton"
            :disabled="!allowDelete(item)"
            @click.prevent="confirmDeleteEntity(item)"
            color="secondary"
            dense
            x-small
          >
            Delete
          </v-btn>
        </v-row>
      </template>

      <template v-if="config.footer" v-slot:body.append="{ headers }">
        <tr v-if="isMobile()">
          <td :colspan="headers.length" class="text-start">
            <span style="font-size: 0.875rem">{{ config.footer.header }}</span>
            <span
              v-for="(header, i) in headers.slice(showActions ? 2 : 1)"
              :key="i"
              class="tw-float-right"
            >
              <span
                v-if="
                  config.reportFileName === 'batch_settlements_report' &&
                  config.footer.displayHeaders.includes(header.value)
                "
                class="tw-mr-2 tw-text-sm"
              >
                {{ header.text }}:
                {{
                  config.footer.displayFunction(
                    $options.filters,
                    items,
                    header.value
                  )
                }}
              </span>
              <span
                class="font-weight-bold"
                v-else-if="config.footer.displayHeaders.includes(header.value)"
              >
                {{
                  config.footer.displayFunction(
                    $options.filters,
                    items,
                    header.value
                  )
                }}
              </span>
              <span v-else></span>
            </span>
          </td>
        </tr>
        <tr v-else>
          <th style="font-size: 0.875rem">{{ config.footer.header }}</th>
          <td
            v-for="(header, i) in headers.slice(showActions ? 2 : 1)"
            :key="i"
            :class="
              config.reportFileName === 'transaction_details_report'
                ? headers[i].align
                : ''
            "
          >
            <div
              class="font-weight-bold"
              v-if="config.footer.displayHeaders.includes(header.value)"
            >
              {{
                config.footer.displayFunction(
                  $options.filters,
                  items,
                  header.value
                )
              }}
            </div>
            <div v-else></div>
          </td>
        </tr>
      </template>
    </v-data-table>
    <AddModal
      :addModal="addModal"
      @closeAddModal="closeAddModal"
      @saveCategory="saveCategory"
    />
    <EditModal
      :editModal="editModal"
      @closeEditModal="closeEditModal"
      @updateCategory="updateCategory"
      :id="categoryId"
    />
    <DeleteModal
      :deleteModal="deleteModal"
      :entitySelectedForDeletion="entitySelectedForDeletion"
      :config="config"
      @deleteEntity="deleteEntity"
      @closeDeleteModal="closeDeleteModal"
      modalAction="close"
    />
    <v-dialog v-model="customModal" max-width="600">
      <template>
        <slot name="customModal" v-bind:closeFunction="closeCustomModal" />
      </template>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import Amount from '@/common/components/inputs/Amount.vue';
import { JsonApiArrayResponse } from '@/jsonApi.types';
import fileDownload from 'js-file-download';
import { DateTime } from 'luxon';
import Vue from 'vue';
import api from '@/common/api';
import debounce from 'lodash/debounce';
import { MccCode } from '@/iso/views/merchants/components/mcc-codes.types';
import { getPreviousMonth } from '@/common/util/dateTime.util';
import { SubscriptionStatus } from '@/common/types/subscriptions.types';
import { BasicEntityFilter, EntityFilterType } from './entities.types';
import DeleteModal from '../modals/DeleteModal.vue';
import AddModal from '../modals/AddModal.vue';
import EditModal from '../modals/EditModal.vue';


export default Vue.extend({
  props: {
    config: {
      type: Object,
      required: true,
    },
    showDownloadCsvButton: {
      type: Boolean,
      required: false,
      default: true,
    },
    showLoginButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    showEditButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    showViewButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    showDeleteButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    showSearch: {
      type: Boolean,
      required: false,
      default: false,
    },
    showActions: {
      type: Boolean,
      required: false,
      default: false,
    },
    showAddButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    openModal: {
      type: Boolean,
      required: false,
      default: false,
    },
    showCustomButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    customButtonText: {
      type: String,
      required: false,
      default: '',
    },
    showCustomSummary: {
      type: Boolean,
      required: false,
      default: false,
    },
    allowAddFunc: {
      type: Function,
      required: false,
      default() {
        return true;
      },
    },
    allowEditFunc: {
      type: Function,
      required: false,
      default() {
        return true;
      },
    },
    allowViewFunc: {
      type: Function,
      required: false,
      default() {
        return true;
      },
    },
    allowDeleteFunc: {
      type: Function,
      required: false,
      default() {
        return true;
      },
    },
    reLoadData: {
      type: Boolean,
      required: false,
      default: false,
    },
    mobileBreakpoint: {
      type: Number,
      default: 600,
      required: false,
    },
    openBatchObj: {
      type: Object,
      required: false,
    },
    search: {
      type: String,
      required: false,
      default: '',
    },
    noDataMessage: {
      type: String,
      default: 'No data available',
    },
  },
  created() {
    if (
      this.config.reportFileName === 'commissions_report'
      || this.config.reportFileName === 'residual_report'
      || this.config.reportFileName === 'affiliates_report'
      || this.config.reportFileName === 'merchant_report'
      || this.config.reportFileName === 'recurring_report'
      || this.config.reportFileName === 'batch_settlements_report'
      || this.config.reportFileName === 'billing_details_report'
      || this.config.reportFileName === 'customer_batch_uploads_report'
      || this.config.reportFileName === 'shopping_carts_report'
    ) this.footerItemsPerPage = [-1, 20, 50, 100];
    else if (this.config.reportFileName === 'transaction_details_report') this.footerItemsPerPage = [20, 50, 100];
    else if (this.config.reportFileName === 'customers_vault_report') this.footerItemsPerPage = [100, 50, 20, -1];

    if (this.config.pageTitle) {
      document.title = this.config.pageTitle;
    }
  },
  data() {
    return {
      EntityFilterType,
      filterDialog: false,
      customModal: false,
      deleteModal: false,
      addModal: false,
      editModal: false,
      categoryId: '',
      autoCompleteSearch: '' as string,
      autoCompleteSearchLoading: false as boolean,
      autoCompleteSearchResults: [] as any[],
      entitySelectedForDeletion: {} as any,
      items: [] as any[],
      meta: {} as any,
      loading: true,
      options: { itemsPerPage: this.config.itemsPerPage || 50 } as any,
      getPreviousMonth,
      footerItemsPerPage: [20, 50, 100, -1],
      loadingdata: false,
      filtered: false,
      exportingCsv: false,
      pendingReload: false,
    };
  },
  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },
    search: {
      handler: debounce(function (this: any) {
        if (this.options.itemsPerPage === -1) {
          this.options.itemsPerPage = '';
        }
        this.getData();
      }, 1000),
      immediate: false,
    },
    autoCompleteSearch() {
      if (this.autoCompleteSearch === '' || !this.autoCompleteSearch) return;
      if (this.autoCompleteSearchLoading) return;

      this.autoCompleteSearchLoading = true;
      api
        .get(this.config.apiFilterSearchPath, {
          params: {
            q: this.autoCompleteSearch,
          },
        })
        .then(({ data: { data: searchResult } }) => {
          this.autoCompleteSearchResults = searchResult.map(
            (result: MccCode) => ({
              text: `${result.mcc} - ${result.combined_description}`,
              value: result.mcc,
            }),
          );
        })
        .finally(() => {
          this.autoCompleteSearchLoading = false;
        });
    },
    reLoadData(newValue: boolean, oldValue: boolean) {
      if (newValue === oldValue) {
        return;
      }
      if (this.loadingdata) {
        this.pendingReload = true;
        return;
      }

      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    updateModel(value: any, component: any): void {
      this.config.filters.forEach((filter: any, index: number) => {
        if (filter.name === component.name) {
          const config = {};
          Object.assign(config, component, { value });
          if (value) Object.assign(this.config.filters[index], config);
        }
      });
    },

    allowEdit(entity: any): boolean {
      return this.allowEditFunc(entity);
    },
    allowView(entity: any): boolean {
      return this.showViewButton && this.allowViewFunc(entity);
    },
    allowDelete(entity: any): boolean {
      return this.allowDeleteFunc(entity);
    },
    getData() {
      if (!this.loadingdata) {
        this.loadingdata = true;
        const {
          page, itemsPerPage, sortBy, sortDesc,
        } = this.options;
        this.loading = true;
        const metaTotal = this.meta.total > 0 ? this.meta.total : '';
        const params: any = {
          page,
          perPage: itemsPerPage === -1 ? metaTotal : itemsPerPage,
          role: '',
          q: this.search,
          sortBy,
          sortDesc,
          ...this.querySearchParams,
        };
        if (this.filtered && this.config.reportFileName === 'batch_settlements_report') {
          this.$emit('reloadOpenBatch', params);
        }
        api
          .get(this.config.apiPath, {
            params,
          })
          .then(this.setEntities)
          .catch(({ response }) => {
            this.loadingdata = false;
            const defaultErrorMsg = 'Failed to load the page. Try again later!';
            switch (response.status) {
              case 403: {
                const error = response?.data?.message || defaultErrorMsg;
                this.$toasted.error(error);
                if (this.config.reportFileName === 'customers_vault_report') {
                  window.location.reload();
                }
                break;
              }
              case 422: {
                const errors = response?.data?.errors || defaultErrorMsg;
                let msg: any = '';
                Object.keys(errors).forEach((key: any, idx: any) => {
                  if (idx > 0) msg += '<br />';
                  msg += `${errors[key]}`;
                });
                this.$toasted.error(msg);
                break;
              }
              default:
                this.$toasted.error(defaultErrorMsg);
            }
          });
      }
    },
    setEntities({ data }: { data: JsonApiArrayResponse<any> }) {
      this.loadingdata = false;
      const tableData = data.data!;

      if (
        this.config.reportFileName === 'batch_settlements_report'
        && data.meta.currentPage === 1
        && this.openBatchObj?.transactionCount > 0
      ) {
        tableData.unshift({
          batchNumber: '',
          id: '',
          netAmount: this.openBatchObj?.netAmount,
          processorId: '',
          refundAmount: this.openBatchObj?.refundedAmount,
          createdAt: 'Open Batch (Not Settled)',
          transactionCount: this.openBatchObj?.transactionCount,
          volume: this.openBatchObj?.volume,
        });
      }

      this.items = tableData.map((item) => {
        const result = {} as any;
        if (typeof item.raw !== 'undefined') {
          result.raw = item.raw;
        }
        this.config.headers.forEach((header: any) => {
          result[header.value] = item[header.value];
          if (this.config.reportFileName === 'recurring_report') {
            if (header.value === 'status') {
              if (item[header.value] === SubscriptionStatus.CANCELED) result.color = 'red';
              else if (item[header.value] === SubscriptionStatus.COMPLETED) result.color = 'light-green';
            }
          } else result.color = '';
        });

        Object.assign(result, item);

        return result;
      });
      this.meta = data.meta;
      if (
        this.config.reportFileName === 'batch_settlements_report'
        && data.meta.currentPage === 1
        && this.openBatchObj?.transactionCount > 0
      ) {
        this.meta.total = data.meta.total === 0 ? 1 : data.meta.total;
      }
      this.loading = false;

      if ([
        'entities_table_data_loaded',
        'ip_whitelists',
        'receipt_settings',
        'helpful_videos_report',
        'helpful_video_categories_report',

      ].includes(this.config.reportFileName)) {
        this.$emit('dataLoaded');
      }
      this.closeFilterDialog();

      if (this.pendingReload) {
        this.pendingReload = false;
        this.getData();
      }
    },
    async downloadCsv() {
      this.exportingCsv = true;
      const params: any = {
        role: '',
        ...this.querySearchParams,
      };
      try {
        const response = await api.get(this.config.apiPath, {
          params,
          responseType: 'blob',
          headers: {
            Accept: 'text/csv',
          },
        });
        fileDownload(
          response.data,
          `${DateTime.local().toFormat('yyyy_MM_dd')}_${this.config.reportFileName}.csv`,
        );
      } catch (error) {
        this.$toasted.error('Failed to export CSV. Try again later.');
      } finally {
        this.exportingCsv = false;
      }
    },
    applyFilter() {
      this.closeFilterDialog();
      this.meta.total = 0;
      this.filtered = true;
      this.$emit('filterApplied');
      this.getData();
    },
    resetFilters() {
      this.config.filters = this.config.filters.map((filter: any) => ({
        ...filter,
        value: this.getDefaultFilterValue(filter),
      }));
      this.closeFilterDialog();
      this.meta.total = 0;
      this.$emit('filterApplied');
      this.getData();
    },
    getDefaultFilterValue(filter: any) {
      if (filter?.type === EntityFilterType.SELECT_CHECK
        && Array.isArray(filter?.defaultValue ?? '')
      ) {
        return filter.defaultValue;
      }
      return filter.type === EntityFilterType.DATE ? [] : '';
    },
    confirmDeleteEntity(entity: any) {
      this.entitySelectedForDeletion = entity;
      this.deleteModal = true;
    },
    deleteEntity() {
      api
        .delete(`${this.config.apiPath}/${this.entitySelectedForDeletion.id}`)
        .then(() => {
          this.items = this.items.filter(
            (item) => item.id !== this.entitySelectedForDeletion.id,
          );
        })
        .catch(({ response }) => {
          const message = response?.data?.message || 'Failed to delete. Try again.';
          this.$toasted.error(`${message} (${response.status})`);
        })
        .finally(() => {
          this.deleteModal = false;
        });
    },
    closeFilterDialog() {
      this.filterDialog = false;
    },
    closeCustomModal() {
      this.customModal = false;
    },
    closeDeleteModal() {
      this.deleteModal = false;
    },
    closeAddModal() {
      this.addModal = false;
    },
    closeEditModal() {
      this.editModal = false;
    },
    editModalFunction(id: any) {
      this.categoryId = id;
      this.editModal = true;
    },
    saveCategory(name: string) {
      api.post(`${this.config.apiPath}/create`, {
        name,
      }).then(this.updateComponentKey);
    },
    updateCategory(category: any) {
      this.closeEditModal();
      api.put(`${this.config.apiPath}/${category.uuid}`, {
        id: category.uuid,
        name: category.name,
      }).then(this.updateComponentKey);
    },
    updateComponentKey() {
      this.$emit('updateComponentKey');
      this.$toasted.success('Category created successfully!');
    },
    isMobile(): boolean {
      if (this.$vuetify.breakpoint.width === 0) return false;

      return this.$vuetify.breakpoint.width < this.mobileBreakpoint;
    },
  },
  computed: {
    querySearchParams(): any {
      let params: any = {};
      if (localStorage) {
        this.config.filters.forEach((filter: any, index: number, filters: any[]) => {
          if (filter?.localStorageKey) {
            const item = localStorage.getItem(filter.localStorageKey);
            if (item) {
              let value;
              try {
                value = JSON.parse(item);
              } finally {
                if (value) Object.assign(filters[index], { value });
              }
            }
          }
        });
      }
      this.config.filters
        .filter((filterItem: any) => filterItem.value !== '')
        .forEach((filterItem: any) => {
          const filter: any = {};
          if (filterItem.compositeValues) {
            filterItem.compositeValues.forEach((value: BasicEntityFilter) => {
              filter[value.name] = value.value;
            });
            params = { ...params, ...filter };
          } else if (this.config.reportFileName === 'transaction_details_report' && (filterItem.name).indexOf('customFields') === 0) {
            if (typeof params.customFields !== 'undefined') {
              const oldCustomFields = params.customFields;
              const newCustomField = { [filterItem.display]: filterItem.value };
              params.customFields = {
                ...oldCustomFields,
                ...newCustomField,
              };
            } else {
              filter.customFields = { [filterItem.display]: filterItem.value };
              params = { ...params, ...filter };
            }
          } else {
            filter[filterItem.name] = filterItem.value;
            params = { ...params, ...filter };
          }
        });
      return params;
    },
    allowAdd(): boolean {
      return this.showAddButton && this.allowAddFunc();
    },
    showHeaderTitle(): boolean {
      return !!this.config.header;
    },
    showFilters(): boolean {
      return this.config.filters && this.config.filters.length > 0;
    },
    showToolbar(): boolean {
      return (
        this.showHeaderTitle || this.showFilters || this.showDownloadCsvButton
      );
    },
    previousMonth(): any {
      const today = new Date();
      today.setMonth(Number(getPreviousMonth()) - 1);
      return today.toISOString();
    },
  },
  components: {
    Amount,
    DeleteModal,
    AddModal,
    EditModal,
  },
});
</script>
